import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import PageOffSitesMenu from './pageOffSitesMenu'
import PageOffLeftSearchBar from './pageOffLeftSearchBar'
import PageOffLeftMenu from './pageOffLeftMenu'

class PageOffCanvasLeft extends React.Component {
  static propTypes = {
    showLeftOffCanvas: PropTypes.bool.isRequired,
    currentSite: PropTypes.string.isRequired,
    menuConfig: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      isSitesMenuOpen: false
    }
  }

  onMainMenuToggle (event) {
    event.preventDefault()
    this.setState({ isSitesMenuOpen: !this.state.isSitesMenuOpen })
  }

  render () {
    const { showLeftOffCanvas, currentSite, menuConfig, location } = this.props
    let offCanvasLeftClass = classNames('page__off-canvas--left', {
      'page__off-canvas--is-active': showLeftOffCanvas
    })

    return (
      <div className={offCanvasLeftClass}>
        <div className='off-canvas-left'>
          <div className='off-canvas-left__top'>
            <a href='https://market.envato.com/'>Envato Market</a>
          </div>

          <div className={`off-canvas-left__current-site -color-${currentSite}`}>
            <span className={`off-canvas-left__site-logo--${currentSite}`}>
              {currentSite}
            </span>

            <a href='#' onClick={this.onMainMenuToggle.bind(this)} className='off-canvas-left__current-site-toggle' />
          </div>

          <PageOffSitesMenu isOpen={this.state.isSitesMenuOpen} currentSite={currentSite} />
          <PageOffLeftSearchBar location={location} />
          <PageOffLeftMenu items={menuConfig} />

        </div>
      </div>
    )
  }
}

export default PageOffCanvasLeft



// WEBPACK FOOTER //
// ./client/components/pageOffCanvasLeft/index.js